import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnimationOptions, LottieModule } from 'ngx-lottie';

@Component({
  selector: 'empty-state',
  standalone: true,
  imports: [CommonModule, TranslateModule, LottieModule],
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent implements OnInit {

  @Input() title: string = this.translate.instant('general.No Data Found');
  @Input() subTitle: string = '';
  @Input() desc: string = '';
  @Input() img: string = '';
  @Input() animationPath: string = '';
  @Input() custClass: string = '';
  options: AnimationOptions|null = null;

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.options = {
      path: this.animationPath || '/assets/js/empty-state-animated.json',
      loop: false,
    };
  }

}
